import React, { useState } from 'react';
import './Fruits.css';

// Import images for fruits
import carrotImage from './images/carrot.jpg';
import BroccolliImage from './images/Broccolli.jpg';
import BeetrootImage from './images/Beetroot.jpg';
import EggplantImage from './images/Eggplant.jpg';
import TomatoImage from './images/Tomato.jpg';
import BellpepperImage from './images/Bellpepper.jpg';
import CauliflowerImage from './images/Cauliflower.jpg';
import CabbageImage from './images/Cabbage.jpg';
import SpinachImage from './images/Spinach.jpg';
import PumpkinImage from './images/Pumpkin.jpg';
import RadishImage from'./images/Raddish.jpg';
import GingerImage from './images/Ginger.jpg';
import GarlicImage from'./images/Garlic.jpg';
import OkraImage from './images/Okra.jpg';
import BeansImage from'./images/Beans.jpg';
import OnionImage from'./images/Onion.jpg';
import LettuceImage from './images/Lettuce.jpg';
import CucumberImage from'./images/Cucumber.jpg';

const fruits = [
  { name: 'Carrot', image: carrotImage },
  { name: 'Broccolli', image: BroccolliImage },
  { name: 'Beetroot', image: BeetrootImage },
  { name: 'Eggplant', image: EggplantImage },
  { name: 'Tomato', image: TomatoImage },
  { name: 'Bell peper', image: BellpepperImage },
  { name: 'Cauliflower', image: CauliflowerImage },
  { name: 'Cabbage', image: CabbageImage },
  { name: 'Spinach', image: SpinachImage },
  { name: 'Pumpkin', image: PumpkinImage },

  { name: 'Radish', image:RadishImage  },
  { name: 'Ginger', image: GingerImage },
   { name: 'Garlic', image: GarlicImage },
  { name: 'Okra (or) Lady finger', image: OkraImage },
  { name: 'beans', image: BeansImage },
   { name: 'onion', image: OnionImage },
  { name: 'Lettuce', image: LettuceImage },
  { name: 'Cucumber', image: CucumberImage },

//   { name: 'Peas', image: orangeImage },
//   { name: 'Corn', image: grapesImage },
//   { name: 'Chillies', image: mangoImage },
//   { name: 'Potato', image: pineappleImage },
//   { name: 'Bottle Gound', image: strawberryImage },

//   { name: 'Mint', image: mangoImage },
//   { name: 'Mushroom', image: pineappleImage },
//   { name: 'Bitter Gound', image: strawberryImage },
];

const Vegetables = () => {
  const [selectedFruit, setSelectedFruit] = useState(null);
  const [quizFruit, setQuizFruit] = useState(null);
  const [quizAnswer, setQuizAnswer] = useState('');
  const [quizResult, setQuizResult] = useState('');

  const speakFruit = (fruitName) => {
    const utterance = new SpeechSynthesisUtterance(fruitName);
    window.speechSynthesis.speak(utterance);
  };

  const handleFruitClick = (fruit) => {
    setSelectedFruit(fruit);
    speakFruit(fruit.name);
  };

  const startQuiz = () => {
    const randomFruit = fruits[Math.floor(Math.random() * fruits.length)];
    setQuizFruit(randomFruit);
    setQuizAnswer('');
    setQuizResult('');
  };

  const submitQuiz = () => {
    if (quizAnswer.toLowerCase() === quizFruit.name.toLowerCase()) {
      setQuizResult('Correct!');
    } else {
      setQuizResult(`Wrong! The correct  vegetable was ${quizFruit.name}`);
    }
  };

  const clearQuiz = () => {
    setQuizFruit(null);
    setQuizAnswer('');
    setQuizResult('');
  };

  const nextQuiz = () => {
    startQuiz();
  };

  return (
    <div className="AppFruits">
      <h1>Learn Vegetables</h1>
      <div className="fruits">
        {fruits.map((fruit) => (
          <div
            key={fruit.name}
            className="fruit-box"
            onClick={() => handleFruitClick(fruit)}
          >
            <img src={fruit.image} alt={fruit.name} className="fruit-image" />
            <p>{fruit.name}</p>
          </div>
        ))}
      </div>
      {selectedFruit && <div className="selected-fruit">You selected: {selectedFruit.name}</div>}
      <div className="quiz-section">
        <h2>Quiz Mode</h2>
        {quizFruit ? (
          <div>
            <p>What vegetable is this?</p>
            <img src={quizFruit.image} alt="Quiz Fruit" className="quiz-image" />
            <input
              type="text"
              value={quizAnswer}
              onChange={(e) => setQuizAnswer(e.target.value)}
              placeholder="Enter Vegetable name"
            />
            <button onClick={submitQuiz}>Submit</button>
            <button onClick={nextQuiz}>Next Vegetable</button>
            <button onClick={clearQuiz}>Clear</button>
            {quizResult && <p>{quizResult}</p>}
          </div>
        ) : (
          <button onClick={startQuiz}>Start Quiz</button>
        )}
      </div>
    </div>
  );
};

export default Vegetables;



